import getAnyLabel from './getAnyLabel';
import { ALL } from '../constant';

/**
 *  Helper used to add ANY option
 * @param {*} values list option
 * @param {*} labels
 * @param {*} facetId
 * @param {*} allLabel
 * @returns
 */
export default function addAnyFacetItem(values, labels, facetId, allLabel) {
	if (!values.find((item) => item.value === ALL)) {
		if (allLabel) {
			return [
				{
					label: getAnyLabel(labels, facetId),
					value: ALL
				},
				...values
			];
		}
	}
	return values;
}
